import { TimeoutError } from './TimeoutError';

export function promiseTimeout<T>(ms: number, promise: Promise<T>) {
    // Create a promise that rejects in <ms> milliseconds
    let timeout = new Promise<T>((resolve, reject) => {
        let timeoutId = setTimeout(() => {
            clearTimeout(timeoutId);
            reject(new TimeoutError(`Timed out in ${ms} ms.`));
        }, ms);
    });

    // Returns a race between our timeout and the passed in promise
    return Promise.race<T>([promise, timeout]);
}

export function delay(ms: number): Promise<any> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Limits your function to be called at most every W milliseconds, where W is wait.
 * Calls over W get dropped.
 * @param fn
 * @param wait
 * @example let throttledFunc = throttle(myFunc,500);
 */
export function throttle(fn: Function, wait: number) {
    let isCalled = false;

    return function (...args: any) {
        if (!isCalled) {
            fn(...args);
            isCalled = true;
            setTimeout(function () {
                isCalled = false;
            }, wait);
        }
    };
}
